'use strict';

import React from 'react';
import { Link } from 'react-scroll'

require('styles//TabIcon.scss');

let TabIconComponent = (props) => (
  <Link className="tab" to={props.anchor} smooth={true} duration={400} id={("tab-icon-" + props.anchor).toLowerCase()}>
    <div className="tab-icon-container">
      <img id={("tab-icon-image-" + props.anchor).toLowerCase()} className="tab-icon" src={'../images/tab_' + props.anchor + '.png'} />
    </div>
    <span id={("tab-icon-text-" + props.anchor).toLowerCase()}>{props.text}</span>
  </Link>
);

TabIconComponent.displayName = 'TabIconComponent';

// Uncomment properties you need
// TabIconComponent.propTypes = {};
// TabIconComponent.defaultProps = {};

export default TabIconComponent;



// WEBPACK FOOTER //
// ./src/components/TabIconComponent.js